import { http } from '@noor/api';
import { env } from '@noor/config';
import * as z from 'zod';
import { parseRbacResponse } from '../lib/parse-response';
import {
  featureSchema,
  featureInputSchema,
  featurePatchSchema,
  type FeatureInput,
  type FeaturePatch,
} from '../model/schema';
import type { FeatureFilters } from '../model/list-params';

const options = { baseURL: env.VITE_CORE_API_URL };
// Front features are served under the actor-prefixed admin namespace.
const base = '/api/v1/admin/authz/features';
const listSchema = z.object({
  list: z.array(featureSchema).nullable(),
  meta: z.object({ total: z.number().int().nonnegative().optional() }).optional(),
});

export const rbacFeatureApi = {
  /** The endpoint is not paginated — the whole set comes back in one response. */
  async list({ q, user_type }: FeatureFilters) {
    const { list } = listSchema.parse(
      await http.get<unknown>(base, {
        ...options,
        query: { search: q, user_type },
      }),
    );
    return { features: list ?? [] };
  },
  async get(id: number) {
    return parseRbacResponse(
      featureSchema,
      await http.get<unknown>(`${base}/${id}`, options),
    );
  },
  async create(body: FeatureInput) {
    return parseRbacResponse(
      featureSchema,
      await http.post<unknown>(base, featureInputSchema.parse(body), options),
    );
  },
  async update(id: number, body: FeaturePatch) {
    return parseRbacResponse(
      featureSchema,
      await http.patch<unknown>(`${base}/${id}`, featurePatchSchema.parse(body), options),
    );
  },
  async remove(id: number) {
    await http.delete<void>(`${base}/${id}`, options);
  },
};
